import React, { useEffect } from 'react';
import { BackgroundFormData } from 'src/store/newJmrPageSlice';
import AustinButton from './austinButton';
import { CaseSources } from 'src/utils/jmrUtils';

interface GeneralUserOptionProps {
  handleChange: (key: keyof BackgroundFormData, value: any) => void;
  backgroundFormData: BackgroundFormData;
}

const GeneralUserOption = ({ handleChange, backgroundFormData }: GeneralUserOptionProps) => {
  useEffect(() => handleChange('caseSource', CaseSources.Austin), []);
  return <AustinButton caseSource={backgroundFormData.caseSource}></AustinButton>;
};

export default GeneralUserOption;
